<template>
    <form>
        <div class="card rounded-0 mb-3">
            <h3 class="card-header">
                Default Export Settings
            </h3>
            <div class="card-body">
                <div class="alert-success">{{successMessage}}</div>
                <div class="alert-warning">{{failureMessage}}</div>
                <div class="form-group" v-for="(exportOption, index) in exportOptions" :key="exportOption.id">
                    <div class="row ">
                        <label :for="exportOption.id" class="col-4 d-flex align-items-center justify-content-end mb-0">
                            {{exportOption.displayText}}
                            <i class="fa fa-info-circle ul-tooltip" data-toggle="tooltip" data-placement="top" v-bind:title="exportOption.toolTipText"></i>
                        </label>
                        <div class="col-md-8">
                            <select :id="exportOption.id" :name="exportOption.id" v-model="exportSelections[index]" class="form-control rounded-0 ParameterEntry">
                                <option v-for="option in exportOption.options" :value="option.value" :key="option.value">{{option.text}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <a href class="btn btn-light" @click.prevent="postForm">Update Default Settings</a>
            </div>
        </div>
    </form>
</template>

<script>
    import accountApiClient from '@/services/apiServices/accountApiClient.js'

    export default {
        name: 'ExportPanel',
        props: {
            exportOptions: {
                type: Array,
                default: () => []
            },
            initialExportSelections: {
                type: Array,
                default: () => []
            },
        },
        methods: {
            postForm: async function () {
                var value = await accountApiClient.PostExport(this.exportSelections);
                if (value.status == 200) {
                    if (value.data.success) {
                        this.$store.commit('SET_USER_SETTINGS', this.exportSelections);
                        this.successMessage = value.data.message;
                    } else {
                        this.failureMessage = value.data.message;
                    }
                } else {
                    this.failureMessage = "Server Interruption"
                }
            }
        },
        data() {
            return {
                exportSelections: [],
                successMessage: "",
                failureMessage: ""
            };
        },
        watch: {
            'initialExportSelections': {
                handler: function (val) {
                    for (var i = 0; i < val.length; i++) {
                        this.exportSelections[i] = val[i];
                    }
                },
                deep: true
            },
            'exportSelections': {
                handler: function () {
                    this.successMessage = '';
                    this.failureMessage = '';
                }
            },
            'successMessage': {
                handler: function () {
                    this.failureMessage = '';
                }
            },
            'failureMessage': {
                handler: function () {
                    this.successMessage = '';
                }
            }
        }
    }
</script>

<style scoped>
</style>